"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.weight = exports.tag = exports.silo = exports.send = exports.search = exports.plus = exports.phone = exports.percent = exports.message = exports.menu = exports.mail = exports.logout = exports.link = exports.key = exports.helpCircle = exports.grid = exports.flagPt = exports.flagNl = exports.externalLink = exports.clock = exports.clipboard = exports.chevronUp = exports.chevronLeft = exports.chevronDown = exports.calendar = exports.bell = exports.barChart = exports.avatar = exports.alignLeft = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * This file was auto-generated! Please do NOT edit directly.
 * Use yarn generate:icons
 */
var alignLeft = function alignLeft(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 10C2 9.44772 2.44772 9 3 9H17C17.5523 9 18 9.44772 18 10C18 10.5523 17.5523 11 17 11H3C2.44772 11 2 10.5523 2 10Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6C2 5.44772 2.44772 5 3 5H21C21.5523 5 22 5.44772 22 6C22 6.55228 21.5523 7 21 7H3C2.44772 7 2 6.55228 2 6Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 14C2 13.4477 2.44772 13 3 13H21C21.5523 13 22 13.4477 22 14C22 14.5523 21.5523 15 21 15H3C2.44772 15 2 14.5523 2 14Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 18C2 17.4477 2.44772 17 3 17H17C17.5523 17 18 17.4477 18 18C18 18.5523 17.5523 19 17 19H3C2.44772 19 2 18.5523 2 18Z"
  }));
};

exports.alignLeft = alignLeft;
alignLeft.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "#006FB7",
  xmlns: "http://www.w3.org/2000/svg"
};

var avatar = function avatar(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.46447 15.4645C5.40215 14.5268 6.67392 14 8 14H16C17.3261 14 18.5979 14.5268 19.5355 15.4645C20.4732 16.4021 21 17.6739 21 19V21C21 21.5523 20.5523 22 20 22C19.4477 22 19 21.5523 19 21V19C19 18.2044 18.6839 17.4413 18.1213 16.8787C17.5587 16.3161 16.7956 16 16 16H8C7.20435 16 6.44129 16.3161 5.87868 16.8787C5.31607 17.4413 5 18.2043 5 19V21C5 21.5523 4.55228 22 4 22C3.44772 22 3 21.5523 3 21V19C3 17.6739 3.52678 16.4021 4.46447 15.4645Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C10.3431 4 9 5.34315 9 7C9 8.65685 10.3431 10 12 10C13.6569 10 15 8.65685 15 7C15 5.34315 13.6569 4 12 4ZM7 7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7C17 9.76142 14.7614 12 12 12C9.23858 12 7 9.76142 7 7Z"
  }));
};

exports.avatar = avatar;
avatar.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "#006FB7",
  xmlns: "http://www.w3.org/2000/svg"
};

var barChart = function barChart(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 9C12.5523 9 13 9.44772 13 10V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V10C11 9.44772 11.4477 9 12 9Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 3C5.44772 3 5 3.44772 5 4V20C5 20.5523 5.44772 21 6 21C6.55228 21 7 20.5523 7 20V4C7 3.44772 6.55228 3 6 3Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 15C17.4477 15 17 15.4477 17 16V20C17 20.5523 17.4477 21 18 21C18.5523 21 19 20.5523 19 20V16C19 15.4477 18.5523 15 18 15Z"
  }));
};

exports.barChart = barChart;
barChart.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "#006FB7",
  xmlns: "http://www.w3.org/2000/svg"
};

var bell = function bell(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.05025 3.05025C8.36301 1.7375 10.1435 1 12 1C13.8565 1 15.637 1.7375 16.9497 3.05025C18.2625 4.36301 19 6.14349 19 8C19 11.3527 19.7171 13.4346 20.3779 14.6461C20.7097 15.2544 21.0328 15.6535 21.2572 15.8904C21.3697 16.0091 21.4581 16.0878 21.5113 16.1322C21.5379 16.1544 21.5558 16.168 21.5635 16.1737C21.5647 16.1746 21.5656 16.1753 21.5663 16.1758C21.9248 16.4221 22.0834 16.8725 21.9571 17.2898C21.8294 17.7115 21.4407 18 21 18H3C2.55933 18 2.17061 17.7115 2.04291 17.2898C1.91657 16.8725 2.07521 16.4221 2.43369 16.1758C2.43439 16.1753 2.43535 16.1746 2.43655 16.1737C2.44425 16.168 2.4621 16.1544 2.48872 16.1322C2.54194 16.0878 2.63032 16.0091 2.7428 15.8904C2.96723 15.6535 3.29031 15.2544 3.62211 14.6461C4.28293 13.4346 5 11.3527 5 8C5 6.14348 5.7375 4.36301 7.05025 3.05025ZM5.14933 16H18.8507C18.7746 15.8753 18.6982 15.7434 18.6221 15.6039C17.7829 14.0654 17 11.6473 17 8C17 6.67392 16.4732 5.40215 15.5355 4.46447C14.5979 3.52678 13.3261 3 12 3C10.6739 3 9.40215 3.52678 8.46447 4.46447C7.52679 5.40215 7 6.67392 7 8C7 11.6473 6.21707 14.0654 5.3779 15.6039C5.3018 15.7434 5.22541 15.8753 5.14933 16Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.76823 20.135C10.246 19.8579 10.8579 20.0205 11.135 20.4982C11.2229 20.6498 11.3491 20.7756 11.5009 20.863C11.6527 20.9504 11.8248 20.9965 12 20.9965C12.1752 20.9965 12.3473 20.9504 12.4991 20.863C12.6509 20.7756 12.7771 20.6498 12.865 20.4982C13.1421 20.0205 13.754 19.8579 14.2318 20.135C14.7095 20.4121 14.8721 21.024 14.595 21.5018C14.3313 21.9564 13.9528 22.3337 13.4973 22.5961C13.0419 22.8584 12.5256 22.9965 12 22.9965C11.4744 22.9965 10.9581 22.8584 10.5027 22.5961C10.0472 22.3337 9.66872 21.9564 9.405 21.5018C9.12788 21.024 9.2905 20.4121 9.76823 20.135Z"
  }));
};

exports.bell = bell;
bell.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "#006FB7",
  xmlns: "http://www.w3.org/2000/svg"
};

var calendar = function calendar(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 5C4.44772 5 4 5.44772 4 6V20C4 20.5523 4.44772 21 5 21H19C19.5523 21 20 20.5523 20 20V6C20 5.44772 19.5523 5 19 5H5ZM2 6C2 4.34315 3.34315 3 5 3H19C20.6569 3 22 4.34315 22 6V20C22 21.6569 20.6569 23 19 23H5C3.34315 23 2 21.6569 2 20V6Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 1C16.5523 1 17 1.44772 17 2V6C17 6.55228 16.5523 7 16 7C15.4477 7 15 6.55228 15 6V2C15 1.44772 15.4477 1 16 1Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1C8.55228 1 9 1.44772 9 2V6C9 6.55228 8.55228 7 8 7C7.44772 7 7 6.55228 7 6V2C7 1.44772 7.44772 1 8 1Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 10C2 9.44771 2.44772 9 3 9H21C21.5523 9 22 9.44771 22 10C22 10.5523 21.5523 11 21 11H3C2.44772 11 2 10.5523 2 10Z"
  }));
};

exports.calendar = calendar;
calendar.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "#006FB7",
  xmlns: "http://www.w3.org/2000/svg"
};

var chevronDown = function chevronDown(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.29289 8.29289C5.68342 7.90237 6.31658 7.90237 6.70711 8.29289L12 13.5858L17.2929 8.29289C17.6834 7.90237 18.3166 7.90237 18.7071 8.29289C19.0976 8.68342 19.0976 9.31658 18.7071 9.70711L12.7071 15.7071C12.3166 16.0976 11.6834 16.0976 11.2929 15.7071L5.29289 9.70711C4.90237 9.31658 4.90237 8.68342 5.29289 8.29289Z"
  }));
};

exports.chevronDown = chevronDown;
chevronDown.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "#006FB7",
  xmlns: "http://www.w3.org/2000/svg"
};

var chevronLeft = function chevronLeft(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7071 5.29289C16.0976 5.68342 16.0976 6.31658 15.7071 6.70711L10.4142 12L15.7071 17.2929C16.0976 17.6834 16.0976 18.3166 15.7071 18.7071C15.3166 19.0976 14.6834 19.0976 14.2929 18.7071L8.29289 12.7071C7.90237 12.3166 7.90237 11.6834 8.29289 11.2929L14.2929 5.29289C14.6834 4.90237 15.3166 4.90237 15.7071 5.29289Z"
  }));
};

exports.chevronLeft = chevronLeft;
chevronLeft.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "#006FB7",
  xmlns: "http://www.w3.org/2000/svg"
};

var chevronUp = function chevronUp(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2929 8.29289C11.6834 7.90237 12.3166 7.90237 12.7071 8.29289L18.7071 14.2929C19.0976 14.6834 19.0976 15.3166 18.7071 15.7071C18.3166 16.0976 17.6834 16.0976 17.2929 15.7071L12 10.4142L6.70711 15.7071C6.31658 16.0976 5.68342 16.0976 5.29289 15.7071C4.90237 15.3166 4.90237 14.6834 5.29289 14.2929L11.2929 8.29289Z"
  }));
};

exports.chevronUp = chevronUp;
chevronUp.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "#006FB7",
  xmlns: "http://www.w3.org/2000/svg"
};

var clipboard = function clipboard(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 5C5.73478 5 5.48043 5.10536 5.29289 5.29289C5.10536 5.48043 5 5.73478 5 6V20C5 20.2652 5.10536 20.5196 5.29289 20.7071C5.48043 20.8946 5.73478 21 6 21H18C18.2652 21 18.5196 20.8946 18.7071 20.7071C18.8946 20.5196 19 20.2652 19 20V6C19 5.73478 18.8946 5.48043 18.7071 5.29289C18.5196 5.10536 18.2652 5 18 5H16C15.4477 5 15 4.55228 15 4C15 3.44772 15.4477 3 16 3H18C18.7956 3 19.5587 3.31607 20.1213 3.87868C20.6839 4.44129 21 5.20435 21 6V20C21 20.7957 20.6839 21.5587 20.1213 22.1213C19.5587 22.6839 18.7957 23 18 23H6C5.20435 23 4.44129 22.6839 3.87868 22.1213C3.31607 21.5587 3 20.7957 3 20V6C3 5.20435 3.31607 4.44129 3.87868 3.87868C4.44129 3.31607 5.20435 3 6 3H8C8.55228 3 9 3.44772 9 4C9 4.55228 8.55228 5 8 5H6Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 3C7 1.89543 7.89543 1 9 1H15C16.1046 1 17 1.89543 17 3V5C17 6.10457 16.1046 7 15 7H9C7.89543 7 7 6.10457 7 5V3ZM15 3H9V5H15V3Z"
  }));
};

exports.clipboard = clipboard;
clipboard.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "#006FB7",
  xmlns: "http://www.w3.org/2000/svg"
};

var clock = function clock(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5C12.5523 5 13 5.44772 13 6V11.382L16.4472 13.1056C16.9412 13.3526 17.1414 13.9532 16.8944 14.4472C16.6474 14.9412 16.0468 15.1414 15.5528 14.8944L11.5528 12.8944C11.214 12.725 11 12.3788 11 12V6C11 5.44772 11.4477 5 12 5Z"
  }));
};

exports.clock = clock;
clock.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "#006FB7",
  xmlns: "http://www.w3.org/2000/svg"
};

var externalLink = function externalLink(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 7C4.73478 7 4.48043 7.10536 4.29289 7.29289C4.10536 7.48043 4 7.73478 4 8V19C4 19.2652 4.10536 19.5196 4.29289 19.7071C4.48043 19.8946 4.73478 20 5 20H16C16.2652 20 16.5196 19.8946 16.7071 19.7071C16.8946 19.5196 17 19.2652 17 19V13C17 12.4477 17.4477 12 18 12C18.5523 12 19 12.4477 19 13V19C19 19.7957 18.6839 20.5587 18.1213 21.1213C17.5587 21.6839 16.7957 22 16 22H5C4.20435 22 3.44129 21.6839 2.87868 21.1213C2.31607 20.5587 2 19.7957 2 19V8C2 7.20435 2.31607 6.44129 2.87868 5.87868C3.44129 5.31607 4.20435 5 5 5H11C11.5523 5 12 5.44772 12 6C12 6.55228 11.5523 7 11 7H5Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 3C14 2.44772 14.4477 2 15 2H21C21.5523 2 22 2.44772 22 3V9C22 9.55228 21.5523 10 21 10C20.4477 10 20 9.55228 20 9V4H15C14.4477 4 14 3.55228 14 3Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7071 2.29289C22.0976 2.68342 22.0976 3.31658 21.7071 3.70711L10.7071 14.7071C10.3166 15.0976 9.68342 15.0976 9.29289 14.7071C8.90237 14.3166 8.90237 13.6834 9.29289 13.2929L20.2929 2.29289C20.6834 1.90237 21.3166 1.90237 21.7071 2.29289Z"
  }));
};

exports.externalLink = externalLink;
externalLink.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "#006FB7",
  xmlns: "http://www.w3.org/2000/svg"
};

var flagNl = function flagNl(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22 8.66666H2V2H22V8.66666Z",
    fill: "#AE1C28"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22 15.3333H2V8.66667H22V15.3333Z",
    fill: "white"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22 22H2V15.3333H22V22Z",
    fill: "#21468B"
  })), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    x: "2",
    y: "2",
    width: "20",
    height: "20",
    rx: "10",
    fill: "white"
  }))));
};

exports.flagNl = flagNl;
flagNl.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var flagPt = function flagPt(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("rect", {
    x: "2",
    y: "2",
    width: "20",
    height: "20",
    rx: "10",
    fill: "url(#pattern0)"
  }), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: "1",
    height: "1"
  }, /*#__PURE__*/_react["default"].createElement("use", {
    xlinkHref: "#image0",
    transform: "translate(-0.01, -0.14) scale(0.0025)"
  })), /*#__PURE__*/_react["default"].createElement("g", {
    id: "image0",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "red",
    d: "M204.8 0H512v512H204.7z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#060",
    d: "M0 0h204.8v512H-.1z"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "#ff0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".6"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    strokeWidth: ".7",
    d: "M293.8 326.6c-34.4-1-192-99.4-193-115.1l8.6-14.5C125 219.7 286.2 315.4 302 312l-8.2 14.6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    strokeWidth: ".7",
    d: "M107.6 195c-3.1 8.3 41.1 35.6 94.3 68 53.2 32.3 99 52.3 102.5 49.5l1.5-2.9c-.6 1-2.2 1.3-4.6.6-14.4-4.2-51.9-21.4-98.3-49.5s-86.8-54.1-93-65.1a6.7 6.7 0 01-.7-3.3h-.2l-1.3 2.3-.2.4zm187 132c-.6 1.1-1.7 1.1-3.7 1-12.9-1.5-52-20.5-98-48.1-53.8-32.2-98.2-61.5-93.3-69.1l1.3-2.4.2.1c-4.3 13 87.6 65.5 93 68.9 53.1 33 98 52.2 102 47.2l-1.5 2.4z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    strokeWidth: ".7",
    d: "M205 221c34.3-.3 76.8-4.7 101.2-14.4L301 198c-14.5 8-57.1 13.3-96.3 14-46.4-.4-79.1-4.7-95.5-15.7l-5 9.1c30.2 12.7 61 15.5 100.8 15.6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    strokeWidth: ".7",
    d: "M307.7 206.8c-.9 1.3-16.8 6.8-40.3 10.8a416 416 0 01-62.6 4.6 444.3 444.3 0 01-60-3.8c-24.5-3.9-37.3-9.3-42-11.2l1.2-2.3a186 186 0 0041.3 11 438.9 438.9 0 0059.5 3.7 417.8 417.8 0 0062.1-4.6c24-3.9 37.2-8.9 39-11.2l1.8 3zM303 198c-2.6 2-15.6 6.7-38.4 10.3a414 414 0 01-59.5 4.2 400 400 0 01-57.4-3.7c-23.3-3-35.6-8.5-40-10.1l1.3-2.3c3.4 1.8 15.4 6.6 39 10a423 423 0 0057.1 3.5 408.6 408.6 0 0059-4.2c23-3.2 35.4-9 37.3-10.5l1.6 2.8zM92 262.4c21.2 11.4 68.1 17.2 112.6 17.6 40.5 0 93.3-6.3 113-16.8l-.6-11.4c-6.1 9.7-62.6 19-112.8 18.6-50.2-.4-96.8-8.2-112.3-18.2v10.2"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    strokeWidth: ".7",
    d: "M318.7 260.8v2.7c-3 3.6-21.6 9-44.9 12.7a463.2 463.2 0 01-69.7 4.8c-27.4 0-49.2-2-66.2-4.6a164.8 164.8 0 01-47.3-12.7v-3.2c10.4 6.9 38.3 11.9 47.7 13.4 16.8 2.6 38.5 4.5 65.8 4.5 28.7 0 51.7-2 69.3-4.7 16.8-2.4 40.6-8.7 45.3-12.9zm0-9.7v2.8c-3 3.5-21.6 8.9-44.9 12.6a463.2 463.2 0 01-69.7 4.8c-27.4 0-49.2-2-66.1-4.5A165 165 0 0190.6 254v-3.2c10.4 6.9 38.3 12 47.7 13.4 16.9 2.6 38.6 4.6 65.8 4.6 28.7 0 51.7-2 69.3-4.8 16.8-2.4 40.6-8.7 45.3-12.9zm-114.2 73.5c-48.6-.3-90.3-13.2-99.1-15.4l6.4 10c15.5 6.6 56.2 16.4 93.2 15.3s69.3-4 92-15l6.6-10.5c-15.5 7.3-68.3 15.6-99 15.6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M299.5 317.1a152.6 152.6 0 01-3 4.4 258.9 258.9 0 01-34.7 8.9 315 315 0 01-57.2 5.2c-43.1-.6-78.4-9-95-16.2l-1.4-2.3.3-.4 2.2.9a305.5 305.5 0 0094.1 15.5c20 .1 40-2.3 56.1-5.1 24.8-5 34.8-8.7 37.9-10.4l.7-.5zm5.7-9.4h.1a302 302 0 01-2.2 3.8c-5.7 2-21.3 6.6-44 9.8-15 2-24.3 4-54 4.6a371 371 0 01-100.5-15l-1.2-2.5a424.4 424.4 0 00101.7 15c27.2-.6 38.8-2.6 53.6-4.7 26.5-4 39.8-8.4 43.8-9.7a3 3 0 00-.1-.2l2.8-1.1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    strokeWidth: ".7",
    d: "M305.8 253.4c.2 32-16.2 60.8-29.4 73.5a106 106 0 01-72.3 30c-32.3.6-62.7-20.5-70.9-29.7-16-18.1-29-41-29.4-72 2-35 15.7-59.3 35.6-76a106.3 106.3 0 0168.4-24.2c25.4.7 55.2 13.2 75.7 38 13.4 16.2 19.3 33.8 22.3 60.5zM204.4 143.8c62 0 113 50.5 113 112.3a113 113 0 01-113 112.3c-62 0-112.6-50.4-112.6-112.3s50.6-112.3 112.6-112.3"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    strokeWidth: ".7",
    d: "M204.7 143.4c62 0 112.6 50.7 112.6 112.7s-50.6 112.7-112.6 112.7A113 113 0 0192 256a113 113 0 01112.7-112.7zM94.5 256.1c0 60.6 49.8 110.2 110.2 110.2 60.4 0 110.1-49.6 110.1-110.2S265.1 146 204.7 146A110.6 110.6 0 0094.5 256.1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    strokeWidth: ".7",
    d: "M204.8 152.8c56.5 0 103.1 46.5 103.1 103.2 0 56.8-46.6 103.2-103.1 103.2A103.6 103.6 0 01101.5 256c0-56.7 46.6-103.2 103.2-103.2zM104 256c0 55.4 45.5 100.7 100.8 100.7 55.2 0 100.7-45.3 100.7-100.7 0-55.4-45.5-100.7-100.8-100.7S104 200.6 104 256z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    strokeWidth: ".7",
    d: "M209.3 143h-9.7v226.4h9.7z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    strokeWidth: ".7",
    d: "M208.3 141.7h2.5v229h-2.5v-229zm-9.6 0h2.5v229h-2.5v-229z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    strokeWidth: ".7",
    d: "M317.4 260.5V252l-6.8-6.3-38.7-10.3-55.8-5.7-67 3.4-47.9 11.4-9.6 7.2v8.3l24.4-11 58-9h55.8l41 4.5 28.4 6.9z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    strokeWidth: ".7",
    d: "M204.7 238.7a394 394 0 0172.9 6.5c21.1 4.2 36 9.5 41 15.4v3c-6-7.4-26-12.8-41.5-16-20.3-3.9-46-6.4-72.4-6.4-28 0-54 2.7-74 6.6-16 3.2-37.4 9.5-40.1 15.8v-3c1.5-4.4 17.4-10.9 39.8-15.4a405 405 0 0174.3-6.5zm0-9.7a396 396 0 0173 6.5c21 4.2 36 9.5 41 15.5v2.9c-6.1-7.4-26.2-12.8-41.6-15.9-20.3-4-46-6.5-72.4-6.5a402 402 0 00-73.8 6.6c-15.5 3-37.8 9.6-40.3 15.8v-3c1.5-4.3 17.8-11 39.8-15.3a405 405 0 0174.3-6.6zm-.5-49.3c41.9-.2 78.5 5.9 95.2 14.5l6.1 10.5c-14.5-7.8-54-16-101.3-14.7-38.5.2-79.6 4.2-100.3 15.2l7.3-12.2c17-8.8 57-13.2 93-13.3"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    strokeWidth: ".7",
    d: "M204.7 188.4c24 0 47 1.3 65.4 4.6 17.1 3.2 33.5 8 35.8 10.6l1.8 3.2c-5.7-3.7-19.8-7.9-38-11.3a367.2 367.2 0 00-65-4.5c-27 0-48 1.3-66 4.5-19 3.5-32.2 8.6-35.5 11l1.8-3.3c6.3-3.3 16.4-7.2 33.3-10.2 18.6-3.4 39.7-4.4 66.4-4.6zm0-9.6a371 371 0 0163.1 4.4c13.9 2.7 27.6 6.9 32.7 10.6l2.6 4.2c-4.5-5-21.4-9.7-36.4-12.3-17.4-3-39.1-4.2-62-4.4-24 0-46.2 1.5-63.4 4.6-16.4 3.2-27 6.9-31.5 9.8l2.3-3.6c6.2-3.2 16.2-6.2 28.8-8.7 17.3-3.1 39.7-4.6 63.8-4.6zm56 124.1a293.3 293.3 0 00-56-4.2c-69.9.8-92.4 14.3-95.2 18.4l-5.2-8.5C122 295.7 160 288.5 205 289.2c23.3.4 43.4 2 60.4 5.2l-4.8 8.5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M204.3 297.5c19.4.3 38.5 1 57 4.5l-1.4 2.4a297.6 297.6 0 00-55.5-4.3c-25.8-.2-52 2.2-74.6 8.7-7.2 2-19 6.6-20.3 10.4l-1.3-2.2c.4-2.2 7.6-6.9 21-10.6 26-7.5 50.3-8.7 75-9zm.9-9.8a351 351 0 0161.1 5.3l-1.4 2.5a319 319 0 00-59.6-5.2c-25.9 0-53.3 1.9-78.3 9.1-8 2.4-22 7.4-22.4 11.4l-1.3-2.3c.3-3.6 12.3-8.4 23.2-11.6a285 285 0 0178.7-9.2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    strokeWidth: ".7",
    d: "M304.4 309.9l-8.4 13-24.1-21.4-62.6-42-70.5-38.8-36.7-12.5 7.8-14.5 2.7-1.4 22.8 5.7 75 38.7 43.3 27.3 36.3 26 14.8 17.1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    strokeWidth: ".7",
    d: "M100.8 208.5c6.5-4.3 53.7 16.7 103 46.5 49.3 29.9 96.4 63.6 92.2 70l-1.4 2.1-.7.5c.2 0 .9-1 0-3.3-2.2-6.9-35.5-33.5-91-67-54-32.2-99-51.6-103.5-46l1.4-2.8zm205.3 101.2c4-8-39.7-41-94-73.1-55.5-31.5-95.6-50-102.9-44.5l-1.6 3c0 .1 0-.2.4-.5 1.3-1.1 3.5-1 4.5-1 12.6.1 48.6 16.6 99 45.6 22.1 12.8 93.4 58.6 93.1 71.4 0 1.1.1 1.3-.3 1.9l1.8-2.8z"
  })), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-68.3 28.4) scale(1.13778)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: ".7",
    d: "M180.6 211a58.7 58.7 0 0017.5 41.7 59 59 0 0041.8 17.6 59.4 59.4 0 0042-17.4 59 59 0 0017.4-41.8v-79.2l-118.7-.2V211z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "red",
    stroke: "#000",
    strokeWidth: ".5",
    d: "M182.8 211.1a56.4 56.4 0 0016.8 40 57 57 0 0040.2 16.8 56.9 56.9 0 0040.2-16.6 56.4 56.4 0 0016.7-40v-77H183v76.8m91-53.7v48.9l-.1 5.1a33.2 33.2 0 01-10 24 34 34 0 01-24 10c-9.4 0-17.7-4-23.9-10.2a34 34 0 01-10-24v-54l68 .2z"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    id: "e"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "d",
    fill: "#ff0",
    stroke: "#000",
    strokeWidth: ".5"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    stroke: "none",
    d: "M190.2 154.4c.1-5.5 4-6.8 4-6.8.1 0 4.3 1.4 4.3 6.9h-8.3"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M186.8 147.7l-.7 6.3h4.2c0-5.2 4-6 4-6 .1 0 4 1.1 4.1 6h4.2l-.8-6.4h-15zm-1 6.4h17c.3 0 .6.3.6.7 0 .5-.3.8-.6.8h-17c-.3 0-.6-.3-.6-.8 0-.4.3-.7.7-.7z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M192 154c0-3.3 2.3-4.2 2.3-4.2s2.3 1 2.3 4.2H192m-5.8-9h16.3c.3 0 .6.4.6.8 0 .3-.3.6-.6.6h-16.3c-.3 0-.6-.3-.6-.7 0-.3.3-.6.6-.6zm.4 1.5H202c.3 0 .6.3.6.7 0 .4-.3.7-.6.7h-15.5c-.4 0-.6-.3-.6-.7 0-.4.2-.7.6-.7zm5-10.6h1.2v.8h.9v-.8h1.3v.9h.9v-1h1.2v2c0 .4-.2.6-.5.6h-4.4c-.3 0-.6-.2-.6-.5v-2zm4.6 2.7l.3 6.4h-4.3l.3-6.5h3.7"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    id: "a",
    d: "M191 141.6v3.4h-4v-3.4h4z"
  }), /*#__PURE__*/_react["default"].createElement("use", {
    width: "100%",
    height: "100%",
    x: "10.6",
    xlinkHref: "#a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    id: "b",
    d: "M186.3 139h1.2v1h.9v-1h1.2v1h.9v-1h1.2v2c0 .4-.2.6-.5.6h-4.3a.6.6 0 01-.6-.6v-2z"
  }), /*#__PURE__*/_react["default"].createElement("use", {
    width: "100%",
    height: "100%",
    x: "10.6",
    xlinkHref: "#b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#000",
    stroke: "none",
    d: "M193.9 140.6c0-.6.9-.6.9 0v1.6h-.9v-1.6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    id: "c",
    fill: "#000",
    stroke: "none",
    d: "M188.6 142.8c0-.6.8-.6.8 0v1.2h-.8v-1.2"
  }), /*#__PURE__*/_react["default"].createElement("use", {
    width: "100%",
    height: "100%",
    x: "10.6",
    xlinkHref: "#c"
  })), /*#__PURE__*/_react["default"].createElement("use", {
    width: "100%",
    height: "100%",
    y: "46.3",
    xlinkHref: "#d"
  }), /*#__PURE__*/_react["default"].createElement("use", {
    width: "100%",
    height: "100%",
    transform: "rotate(-45.2 312.8 180)",
    xlinkHref: "#d"
  })), /*#__PURE__*/_react["default"].createElement("use", {
    width: "100%",
    height: "100%",
    x: "45.7",
    xlinkHref: "#d"
  }), /*#__PURE__*/_react["default"].createElement("use", {
    width: "100%",
    height: "100%",
    transform: "matrix(-1 0 0 1 479.8 0)",
    xlinkHref: "#e"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#039",
    d: "M232.6 202.4a8.3 8.3 0 002.2 5.7 7.2 7.2 0 005.3 2.4c2.1 0 4-1 5.3-2.4a8.3 8.3 0 002.2-5.7v-10.8h-15v10.8"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "236.1",
    cy: "195.7",
    r: "1.5"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "244.4",
    cy: "195.7",
    r: "1.5"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "240.2",
    cy: "199.7",
    r: "1.5"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "236.1",
    cy: "203.9",
    r: "1.5"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "244.4",
    cy: "203.9",
    r: "1.5"
  })), /*#__PURE__*/_react["default"].createElement("use", {
    width: "100%",
    height: "100%",
    y: "-26",
    xlinkHref: "#f"
  }), /*#__PURE__*/_react["default"].createElement("use", {
    width: "100%",
    height: "100%",
    x: "-20.8",
    xlinkHref: "#f"
  }), /*#__PURE__*/_react["default"].createElement("use", {
    width: "100%",
    height: "100%",
    x: "20.8",
    xlinkHref: "#f"
  }), /*#__PURE__*/_react["default"].createElement("use", {
    width: "100%",
    height: "100%",
    y: "25.8",
    xlinkHref: "#f"
  })))));
};

exports.flagPt = flagPt;
flagPt.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};

var grid = function grid(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 3C2 2.44772 2.44772 2 3 2H10C10.5523 2 11 2.44772 11 3V10C11 10.5523 10.5523 11 10 11H3C2.44772 11 2 10.5523 2 10V3ZM4 4V9H9V4H4Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 3C13 2.44772 13.4477 2 14 2H21C21.5523 2 22 2.44772 22 3V10C22 10.5523 21.5523 11 21 11H14C13.4477 11 13 10.5523 13 10V3ZM15 4V9H20V4H15Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 14C13 13.4477 13.4477 13 14 13H21C21.5523 13 22 13.4477 22 14V21C22 21.5523 21.5523 22 21 22H14C13.4477 22 13 21.5523 13 21V14ZM15 15V20H20V15H15Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 14C2 13.4477 2.44772 13 3 13H10C10.5523 13 11 13.4477 11 14V21C11 21.5523 10.5523 22 10 22H3C2.44772 22 2 21.5523 2 21V14ZM4 15V20H9V15H4Z"
  }));
};

exports.grid = grid;
grid.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "#006FB7",
  xmlns: "http://www.w3.org/2000/svg"
};

var helpCircle = function helpCircle(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2581 8.02432C11.7926 7.94447 11.3138 8.03195 10.9066 8.27127C10.4994 8.51058 10.1901 8.88629 10.0333 9.33184C9.85006 9.85283 9.27915 10.1266 8.75816 9.94333C8.23717 9.76006 7.96339 9.18915 8.14667 8.66816C8.46014 7.77705 9.07887 7.02563 9.89327 6.547C10.7077 6.06837 11.6652 5.89341 12.5962 6.05311C13.5273 6.2128 14.3718 6.69686 14.9801 7.41953C15.5883 8.14205 15.9213 9.05648 15.92 10.0009C15.9195 11.5313 14.7849 12.5419 13.9747 13.0821C13.5391 13.3725 13.1106 13.586 12.7949 13.7263C12.6356 13.7971 12.5015 13.8508 12.4049 13.8876C12.3565 13.9061 12.3173 13.9203 12.2887 13.9305L12.254 13.9427L12.2429 13.9464L12.239 13.9478L12.2375 13.9483C12.2375 13.9483 12.2362 13.9487 11.92 13L12.2362 13.9487C11.7123 14.1233 11.146 13.8402 10.9713 13.3162C10.7968 12.7926 11.0795 12.2267 11.6027 12.0517L11.6014 12.0521L11.6027 12.0517L11.6187 12.0461C11.6341 12.0406 11.6593 12.0314 11.6929 12.0186C11.7603 11.9929 11.8606 11.9529 11.9826 11.8987C12.2294 11.789 12.5509 11.6275 12.8653 11.4179C13.5549 10.9582 13.92 10.4691 13.92 10L13.92 9.99851C13.9207 9.52619 13.7542 9.06886 13.4501 8.70753C13.1459 8.34619 12.7236 8.10417 12.2581 8.02432Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 17C11 16.4477 11.4477 16 12 16H12.01C12.5623 16 13.01 16.4477 13.01 17C13.01 17.5523 12.5623 18 12.01 18H12C11.4477 18 11 17.5523 11 17Z"
  }));
};

exports.helpCircle = helpCircle;
helpCircle.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "#006FB7",
  xmlns: "http://www.w3.org/2000/svg"
};

var key = function key(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7071 1.29289C22.0976 1.68342 22.0976 2.31658 21.7071 2.70711L20.4142 4L22.7071 6.29289C23.0976 6.68342 23.0976 7.31658 22.7071 7.70711L19.2071 11.2071C18.8166 11.5976 18.1834 11.5976 17.7929 11.2071L15.5 8.91421L12.7536 11.6607C13.061 12.0765 13.3185 12.5285 13.5197 13.0075C13.8517 13.7978 14.0241 14.646 14.027 15.5033C14.0299 16.3605 13.8632 17.2099 13.5364 18.0024C13.2097 18.795 12.7294 19.5151 12.1233 20.1213C11.5171 20.7274 10.797 21.2077 10.0044 21.5344C9.21189 21.8612 8.36253 22.0279 7.50528 22.025C6.64803 22.0221 5.79981 21.8497 5.00947 21.5177C4.21913 21.1857 3.50227 20.7006 2.90017 20.0904L2.89267 20.0828C1.70864 18.8568 1.05352 17.2149 1.06833 15.5106C1.08314 13.8063 1.76674 12.176 2.97189 10.9709C4.17704 9.76574 5.80733 9.08214 7.5116 9.06733C8.88443 9.0554 10.2168 9.47819 11.3238 10.2619L20.2929 1.29289C20.6834 0.902369 21.3166 0.902369 21.7071 1.29289ZM19 5.41421L16.9142 7.5L18.5 9.08579L20.5858 7L19 5.41421ZM12.0961 12.3181C11.7193 12.6949 11.1154 12.7088 10.7219 12.3559C10.713 12.347 10.7041 12.3382 10.6952 12.3293C10.6927 12.3268 10.6902 12.3243 10.6876 12.3218L11.3884 11.6116M4.3276 18.6895C3.51021 17.8412 3.05802 16.7061 3.06825 15.528C3.07851 14.3481 3.55177 13.2194 4.3861 12.3851C5.22044 11.5508 6.3491 11.0775 7.52898 11.0673C8.70887 11.057 9.84558 11.5106 10.6943 12.3303C10.7034 12.339 10.7125 12.3476 10.7219 12.3559C11.1283 12.7656 11.4522 13.2498 11.6758 13.7821C11.9057 14.3293 12.025 14.9165 12.027 15.51C12.029 16.1035 11.9136 16.6915 11.6874 17.2402C11.4612 17.7889 11.1287 18.2874 10.709 18.707C10.2894 19.1267 9.79086 19.4592 9.24217 19.6854C8.69348 19.9116 8.10546 20.027 7.51198 20.025C6.9185 20.023 6.33127 19.9037 5.78411 19.6738C5.2386 19.4446 4.74365 19.1101 4.3276 18.6895ZM4.3276 18.6895L4.33129 18.6933L3.612 19.388L4.32383 18.6856L4.3276 18.6895ZM12.0961 12.3181L12.0971 12.3171L12.0961 12.3181Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.7219 12.3559C11.1154 12.7088 11.7193 12.6949 12.0961 12.3181L11.3884 11.6116L10.6876 12.3218L10.6952 12.3293L10.7219 12.3559Z"
  }));
};

exports.key = key;
key.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "#006FB7",
  xmlns: "http://www.w3.org/2000/svg"
};

var link = function link(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7752 2.75071C13.9069 1.65776 15.4225 1.053 16.9956 1.06667C18.5688 1.08034 20.0737 1.71135 21.1862 2.8238C22.2986 3.93625 22.9296 5.44112 22.9433 7.0143C22.957 8.58748 22.3522 10.1031 21.2592 11.2347L21.2471 11.2471L18.2472 14.247C17.639 14.8554 16.9069 15.326 16.1008 15.6267C15.2947 15.9274 14.4333 16.0512 13.5752 15.9898C12.717 15.9283 11.8821 15.683 11.1271 15.2705C10.372 14.858 9.71453 14.2879 9.19919 13.599C8.86838 13.1567 8.95873 12.53 9.40098 12.1992C9.84323 11.8684 10.4699 11.9588 10.8007 12.401C11.1443 12.8603 11.5826 13.2404 12.086 13.5154C12.5893 13.7904 13.1459 13.9539 13.718 13.9949C14.2902 14.0359 14.8644 13.9533 15.4018 13.7528C15.9392 13.5524 16.4272 13.2387 16.8327 12.833L19.8264 9.83934C20.5514 9.08557 20.9525 8.07772 20.9434 7.03168C20.9343 5.9829 20.5136 4.97965 19.7719 4.23801C19.0303 3.49638 18.0271 3.07571 16.9783 3.06659C15.9318 3.0575 14.9235 3.45891 14.1696 4.18455L12.455 5.88916C12.0633 6.27855 11.4302 6.2767 11.0408 5.88504C10.6514 5.49338 10.6533 4.86022 11.0449 4.47083L12.7649 2.76083L12.7752 2.75071ZM7.89911 8.37328C8.70522 8.07258 9.56657 7.94876 10.4247 8.01022C11.2829 8.07168 12.1178 8.31698 12.8729 8.72949C13.6279 9.142 14.2854 9.71207 14.8007 10.401C15.1315 10.8433 15.0412 11.47 14.5989 11.8008C14.1567 12.1316 13.53 12.0412 13.1992 11.599C12.8556 11.1397 12.4173 10.7596 11.9139 10.4846C11.4106 10.2096 10.854 10.0461 10.2819 10.0051C9.70976 9.96414 9.13552 10.0467 8.59811 10.2472C8.06071 10.4476 7.5727 10.7613 7.16719 11.167L4.17355 14.1606C3.44851 14.9144 3.04746 15.9223 3.05655 16.9683C3.06566 18.0171 3.48634 19.0204 4.22797 19.762C4.9696 20.5036 5.97285 20.9243 7.02164 20.9334C8.0677 20.9425 9.07557 20.5414 9.82935 19.8164L11.5328 18.1129C11.9234 17.7224 12.5565 17.7224 12.9471 18.1129C13.3376 18.5034 13.3376 19.1366 12.9471 19.5271L11.2371 21.2371L11.2247 21.2493C10.0931 22.3422 8.57744 22.947 7.00426 22.9333C5.43108 22.9197 3.9262 22.2886 2.81376 21.1762C1.70131 20.0638 1.07029 18.5589 1.05662 16.9857C1.04295 15.4125 1.64772 13.8969 2.74067 12.7653L2.75285 12.7529L5.75272 9.75302C6.36096 9.1446 7.09305 8.67396 7.89911 8.37328Z"
  }));
};

exports.link = link;
link.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "#006FB7",
  xmlns: "http://www.w3.org/2000/svg"
};

var logout = function logout(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 4C4.73478 4 4.48043 4.10536 4.29289 4.29289C4.10536 4.48043 4 4.73478 4 5V19C4 19.2652 4.10536 19.5196 4.29289 19.7071C4.48043 19.8946 4.73478 20 5 20H9C9.55228 20 10 20.4477 10 21C10 21.5523 9.55228 22 9 22H5C4.20435 22 3.44129 21.6839 2.87868 21.1213C2.31607 20.5587 2 19.7957 2 19V5C2 4.20435 2.31607 3.44129 2.87868 2.87868C3.44129 2.31607 4.20435 2 5 2H9C9.55228 2 10 2.44772 10 3C10 3.55228 9.55228 4 9 4H5Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2929 6.29289C15.6834 5.90237 16.3166 5.90237 16.7071 6.29289L21.7071 11.2929C22.0976 11.6834 22.0976 12.3166 21.7071 12.7071L16.7071 17.7071C16.3166 18.0976 15.6834 18.0976 15.2929 17.7071C14.9024 17.3166 14.9024 16.6834 15.2929 16.2929L19.5858 12L15.2929 7.70711C14.9024 7.31658 14.9024 6.68342 15.2929 6.29289Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 12C8 11.4477 8.44772 11 9 11H21C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H9C8.44772 13 8 12.5523 8 12Z"
  }));
};

exports.logout = logout;
logout.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "#006FB7",
  xmlns: "http://www.w3.org/2000/svg"
};

var mail = function mail(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99999 5C3.45228 5 2.99999 5.45228 2.99999 6V18C2.99999 18.5477 3.45228 19 3.99999 19H20C20.5477 19 21 18.5477 21 18V6C21 5.45228 20.5477 5 20 5H3.99999ZM0.999994 6C0.999994 4.34772 2.34771 3 3.99999 3H20C21.6523 3 23 4.34772 23 6V18C23 19.6523 21.6523 21 20 21H3.99999C2.34771 21 0.999994 19.6523 0.999994 18V6Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.18076 5.42654C1.49748 4.97409 2.12101 4.86405 2.57346 5.18077L12 11.7793L21.4265 5.18077C21.879 4.86405 22.5025 4.97409 22.8192 5.42654C23.1359 5.87899 23.0259 6.50252 22.5735 6.81923L12.5735 13.8192C12.2291 14.0603 11.7709 14.0603 11.4265 13.8192L1.42653 6.81923C0.974083 6.50252 0.864048 5.87899 1.18076 5.42654Z"
  }));
};

exports.mail = mail;
mail.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "#006FB7",
  xmlns: "http://www.w3.org/2000/svg"
};

var menu = function menu(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1C0 0.447715 0.447715 0 1 0H19C19.5523 0 20 0.447715 20 1C20 1.55228 19.5523 2 19 2H1C0.447715 2 0 1.55228 0 1ZM0 7C0 6.44772 0.447715 6 1 6H19C19.5523 6 20 6.44772 20 7C20 7.55228 19.5523 8 19 8H1C0.447715 8 0 7.55228 0 7ZM0 13C0 12.4477 0.447715 12 1 12H19C19.5523 12 20 12.4477 20 13C20 13.5523 19.5523 14 19 14H1C0.447715 14 0 13.5523 0 13Z"
  }));
};

exports.menu = menu;
menu.defaultProps = {
  width: "20",
  height: "14",
  viewBox: "0 0 20 14",
  fill: "#006FB7",
  xmlns: "http://www.w3.org/2000/svg"
};

var message = function message(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 4C4.73478 4 4.48043 4.10536 4.29289 4.29289C4.10536 4.48043 4 4.73478 4 5V18.5858L6.29289 16.2929C6.48043 16.1054 6.73478 16 7 16H19C19.2652 16 19.5196 15.8946 19.7071 15.7071C19.8946 15.5196 20 15.2652 20 15V5C20 4.73478 19.8946 4.48043 19.7071 4.29289C19.5196 4.10536 19.2652 4 19 4H5ZM2.87868 2.87868C3.44129 2.31607 4.20435 2 5 2H19C19.7957 2 20.5587 2.31607 21.1213 2.87868C21.6839 3.44129 22 4.20435 22 5V15C22 15.7957 21.6839 16.5587 21.1213 17.1213C20.5587 17.6839 19.7957 18 19 18H7.41421L3.70711 21.7071C3.42111 21.9931 2.99099 22.0787 2.61732 21.9239C2.24364 21.7691 2 21.4045 2 21V5C2 4.20435 2.31607 3.44129 2.87868 2.87868Z"
  }));
};

exports.message = message;
message.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "#006FB7",
  xmlns: "http://www.w3.org/2000/svg"
};

var percent = function percent(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7071 4.29289C20.0976 4.68342 20.0976 5.31658 19.7071 5.70711L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L18.2929 4.29289C18.6834 3.90237 19.3166 3.90237 19.7071 4.29289Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 5C5.67157 5 5 5.67157 5 6.5C5 7.32843 5.67157 8 6.5 8C7.32843 8 8 7.32843 8 6.5C8 5.67157 7.32843 5 6.5 5ZM3 6.5C3 4.567 4.567 3 6.5 3C8.433 3 10 4.567 10 6.5C10 8.433 8.433 10 6.5 10C4.567 10 3 8.433 3 6.5Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 16C16.6716 16 16 16.6716 16 17.5C16 18.3284 16.6716 19 17.5 19C18.3284 19 19 18.3284 19 17.5C19 16.6716 18.3284 16 17.5 16ZM14 17.5C14 15.567 15.567 14 17.5 14C19.433 14 21 15.567 21 17.5C21 19.433 19.433 21 17.5 21C15.567 21 14 19.433 14 17.5Z"
  }));
};

exports.percent = percent;
percent.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "#006FB7",
  xmlns: "http://www.w3.org/2000/svg"
};

var phone = function phone(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7488 21.13C22.9161 20.7472 23.0017 20.3337 23 19.9159L22.9997 16.9448C23.0179 16.2092 22.7652 15.4925 22.2895 14.931C21.8138 14.3696 21.1483 14.0026 20.4197 13.8998L20.4108 13.8986C19.5258 13.7819 18.6569 13.5655 17.8206 13.2535C17.2841 13.0521 16.7011 13.0085 16.1405 13.1281C15.5796 13.2477 15.0647 13.5257 14.6569 13.9289L14.6529 13.9329L13.9358 14.65C12.0911 13.4741 10.5259 11.9088 9.35001 10.0642L10.0671 9.34712L10.071 9.34314C10.4743 8.9353 10.7523 8.42041 10.8719 7.85946C10.9915 7.29893 10.9479 6.7159 10.7465 6.17935C10.4345 5.34306 10.2182 4.47416 10.1015 3.58923L10.1002 3.58005C9.99827 2.85922 9.63775 2.20003 9.0858 1.72535C8.53521 1.25184 7.83161 0.994161 7.10557 0.999998L4.10905 0.999998C3.69256 1.00039 3.28072 1.0875 2.89974 1.25578C2.51876 1.42406 2.17699 1.66983 1.8962 1.97743C1.61541 2.28503 1.40174 2.64773 1.2688 3.04243C1.13586 3.43714 1.08657 3.8552 1.12405 4.27L1.12559 4.2856C1.47026 7.53131 2.5743 10.6503 4.34831 13.39C5.92713 15.8739 7.87864 18.2003 10.4597 19.8415C13.2222 21.6318 16.5283 22.5682 19.712 22.9141L19.73 22.9159C20.146 22.9535 20.5654 22.9038 20.9611 22.77C21.3568 22.6362 21.7203 22.4212 22.0281 22.1387C22.3359 21.8563 22.5814 21.5127 22.7488 21.13ZM7.11984 2.99995C7.36249 2.99756 7.59773 3.08349 7.78172 3.24172C7.96475 3.39913 8.08463 3.61741 8.1193 3.85623C8.25596 4.88918 8.50882 5.9034 8.8731 6.8796L8.87394 6.88186C8.94121 7.06082 8.95577 7.25532 8.9159 7.4423C8.87617 7.62854 8.7841 7.79956 8.65053 7.93525L7.38289 9.20289C7.06457 9.5212 6.99819 10.013 7.2207 10.4043C8.73323 13.0643 10.9357 15.2668 13.5957 16.7793C13.987 17.0018 14.4788 16.9354 14.7971 16.6171L16.0648 15.3494C16.2005 15.2159 16.3715 15.1238 16.5577 15.0841C16.7447 15.0442 16.9392 15.0588 17.1181 15.126L17.1204 15.1269C18.0966 15.4912 19.1109 15.7441 20.1439 15.8807C20.3854 15.9157 20.6058 16.0377 20.7636 16.2239C20.9221 16.4111 21.0064 16.65 21.0003 16.8952C20.9999 16.9121 20.9999 16.929 21.0003 16.9457V19.8949C21.0001 19.9046 21 19.9143 21 19.9241C21.0006 20.0633 20.972 20.2011 20.9163 20.3287C20.8605 20.4563 20.7787 20.5709 20.676 20.665C20.5734 20.7591 20.4523 20.8308 20.3204 20.8754C20.1909 20.9192 20.0538 20.936 19.9175 20.9247C16.9518 20.6012 13.9721 19.7355 11.5441 18.1609L11.5363 18.156C9.28831 16.7275 7.52468 14.6595 6.03404 12.3137L6.02927 12.3063C4.4263 9.83187 3.42811 7.01499 3.11536 4.08343C3.10397 3.94732 3.12057 3.8103 3.16419 3.68081C3.2085 3.54924 3.27972 3.42834 3.37332 3.32581C3.46692 3.22327 3.58084 3.14135 3.70783 3.08526C3.83473 3.02921 3.97189 3.00017 4.11061 3L7.10999 3.00005L7.11984 2.99995Z"
  }));
};

exports.phone = phone;
phone.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "#006FB7",
  xmlns: "http://www.w3.org/2000/svg"
};

var plus = function plus(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C12.5523 4 13 4.44772 13 5V19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19V5C11 4.44772 11.4477 4 12 4Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 12C4 11.4477 4.44772 11 5 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H5C4.44772 13 4 12.5523 4 12Z"
  }));
};

exports.plus = plus;
plus.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "#006FB7",
  xmlns: "http://www.w3.org/2000/svg"
};

var search = function search(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 4C7.13401 4 4 7.13401 4 11C4 14.866 7.13401 18 11 18C14.866 18 18 14.866 18 11C18 7.13401 14.866 4 11 4ZM2 11C2 6.02944 6.02944 2 11 2C15.9706 2 20 6.02944 20 11C20 15.9706 15.9706 20 11 20C6.02944 20 2 15.9706 2 11Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9429 15.9429C16.3334 15.5524 16.9666 15.5524 17.3571 15.9429L21.7071 20.2929C22.0976 20.6834 22.0976 21.3166 21.7071 21.7071C21.3166 22.0976 20.6834 22.0976 20.2929 21.7071L15.9429 17.3571C15.5524 16.9666 15.5524 16.3334 15.9429 15.9429Z"
  }));
};

exports.search = search;
search.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var send = function send(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7071 1.29289C23.0976 1.68342 23.0976 2.31658 22.7071 2.70711L11.7071 13.7071C11.3166 14.0976 10.6834 14.0976 10.2929 13.7071C9.90237 13.3166 9.90237 12.6834 10.2929 12.2929L21.2929 1.29289C21.6834 0.902368 22.3166 0.902368 22.7071 1.29289Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7071 1.29289C22.9787 1.56453 23.0708 1.96776 22.9439 2.33035L15.9439 22.3304C15.8084 22.7174 15.4504 22.9825 15.0408 22.9992C14.6311 23.0159 14.2527 22.7808 14.0862 22.4061L10.2424 13.7576L1.59387 9.91381C1.21919 9.74729 0.984122 9.36892 1.00084 8.95924C1.01755 8.54956 1.28265 8.19159 1.66965 8.05614L21.6697 1.05614C22.0322 0.929235 22.4355 1.02125 22.7071 1.29289ZM4.71108 9.1106L11.4061 12.0862C11.6324 12.1867 11.8133 12.3676 11.9138 12.5939L14.8894 19.2889L20.37 3.62997L4.71108 9.1106Z"
  }));
};

exports.send = send;
send.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "#006FB7",
  xmlns: "http://www.w3.org/2000/svg"
};

var silo = function silo(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00187 4.09482L9.00728 10.0662C9.01062 13.7555 10.0072 17.3758 11.8923 20.547L12.1302 20.9473L12.3675 20.5466C14.2468 17.3719 15.2368 13.7498 15.2335 10.0606L15.2281 4.08919C15.2261 4.08084 15.2229 4.06859 15.2176 4.05315C15.1985 3.9976 15.1488 3.88626 15.0156 3.75656C14.7556 3.50361 14.0227 3.03889 12.114 3.04062C10.2054 3.04235 9.47327 3.50839 9.21381 3.76182C9.08078 3.89176 9.03128 4.00318 9.01234 4.05876C9.00707 4.07421 9.00381 4.08647 9.00187 4.09482ZM16.228 4.04204C17.228 4.04113 17.228 4.0391 17.228 4.0391L17.228 4.03702L17.228 4.03269L17.2279 4.0234L17.2273 4.00231C17.2268 3.98716 17.226 3.96981 17.2246 3.9504C17.2219 3.91162 17.2173 3.86442 17.2092 3.81002C17.1932 3.70136 17.1637 3.56266 17.1094 3.40444C16.9996 3.08414 16.7918 2.69442 16.4105 2.3233C15.6412 1.57462 14.3167 1.03863 12.1122 1.04062C9.90778 1.04262 8.58423 1.58101 7.81631 2.33108C7.43566 2.70289 7.22854 3.09298 7.11929 3.41348C7.06533 3.5718 7.03604 3.71056 7.02022 3.81924C7.0123 3.87366 7.0077 3.92086 7.00508 3.95965C7.00377 3.97906 7.00296 3.99642 7.00247 4.01157L7.00196 4.03266L7.00186 4.04195L7.00184 4.04628L7.00183 4.04836C7.00183 4.04836 7.00183 4.05039 8.00183 4.04948L7.00183 4.05039L7.00728 10.068C7.01094 14.1164 8.10449 18.0891 10.1731 21.569L11.0485 23.0416L13.2158 23.0396L14.0885 21.5654C16.1508 18.0818 17.2372 14.1071 17.2335 10.0588L17.228 4.04113L16.228 4.04204Z"
  }));
};

exports.silo = silo;
silo.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "#006FB7",
  xmlns: "http://www.w3.org/2000/svg"
};

var tag = function tag(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 2C1 1.44772 1.44772 1 2 1H12C12.2652 1 12.5196 1.10536 12.7071 1.29289L21.2992 9.885C21.858 10.4471 22.1716 11.2074 22.1716 12C22.1716 12.7926 21.858 13.5529 21.2992 14.115L20.59 13.41L21.2971 14.1171L14.1275 21.2867C13.849 21.5655 13.5178 21.787 13.1538 21.9379C12.7896 22.0889 12.3992 22.1666 12.005 22.1666C11.6108 22.1666 11.2204 22.0889 10.8562 21.9379C10.4921 21.787 10.1613 21.5658 9.88271 21.2869L1.29331 12.7075C1.10552 12.5199 1 12.2654 1 12V2ZM19.8808 12.705L19.8817 12.7041C20.0674 12.5168 20.1716 12.2638 20.1716 12C20.1716 11.7362 20.0674 11.4832 19.8817 11.2959L19.8808 11.295L11.5858 3H3V11.5854L11.2967 19.8725L11.2975 19.8733C11.3904 19.9663 11.5007 20.04 11.6221 20.0903C11.7435 20.1407 11.8736 20.1666 12.005 20.1666C12.1364 20.1666 12.2665 20.1407 12.3879 20.0903C12.5093 20.04 12.6196 19.9663 12.7125 19.8733L19.8808 12.705Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 7C6 6.44772 6.44772 6 7 6H7.01C7.56228 6 8.01 6.44772 8.01 7C8.01 7.55228 7.56228 8 7.01 8H7C6.44772 8 6 7.55228 6 7Z"
  }));
};

exports.tag = tag;
tag.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "#006FB7",
  xmlns: "http://www.w3.org/2000/svg"
};

var weight = function weight(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.67583 8.84921C4.98086 7.4766 6.1983 6.5 7.60439 6.5H16.3957C17.8018 6.5 19.0192 7.4766 19.3243 8.84921L21.4354 18.3492C21.8517 20.2227 20.4261 22 18.5068 22H5.49328C3.57404 22 2.14838 20.2227 2.56472 18.3492L4.67583 8.84921ZM7.60439 8.5C7.1357 8.5 6.72988 8.82553 6.62821 9.28307L4.5171 18.7831C4.37832 19.4076 4.85354 20 5.49328 20H18.5068C19.1466 20 19.6218 19.4076 19.483 18.7831L17.3719 9.28307C17.2702 8.82553 16.8644 8.5 16.3957 8.5H7.60439Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 6C12.5523 6 13.0001 5.55228 13.0001 5C13.0001 4.44772 12.5523 4 12.0001 4C11.4478 4 11.0001 4.44772 11.0001 5C11.0001 5.55228 11.4478 6 12.0001 6ZM12.0001 8C13.6569 8 15.0001 6.65685 15.0001 5C15.0001 3.34315 13.6569 2 12.0001 2C10.3432 2 9.00005 3.34315 9.00005 5C9.00005 6.65685 10.3432 8 12.0001 8Z"
  }));
};

exports.weight = weight;
weight.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "#006FB7",
  xmlns: "http://www.w3.org/2000/svg"
};
